import { animate } from '../../core/animations';

const columns_per_tile_desktop = 3;
const columns_per_tile_mobile = 6;

const marketingBlockTemplate = () => {
  // Grid is 12 on mobile with 2 product tiles per row
  // Grid is 15 after mobile breakpoint with 5 tiles per row
  return `<%
    var classes = '';
    var width_desktop = columns_per_tile_desktop;
    var width_mobile = columns_per_tile_mobile;
    switch (data.format) {
      case 'tile':
        classes = 'column-xs-' + columns_per_tile_mobile + ' column-sm-' + columns_per_tile_desktop;
        width_desktop = columns_per_tile_desktop;
        width_mobile = columns_per_tile_mobile;
      break;
      case 'half':
        classes = 'column-xs-' + (columns_per_tile_mobile * 2) + ' column-sm-' + (columns_per_tile_desktop * 2);
        width_desktop = columns_per_tile_desktop * 2;
        width_mobile = columns_per_tile_mobile * 2;
      break;
      case 'full':
        classes = 'column-xs-' + (columns_per_tile_mobile * 2) + ' column-sm-' + (columns_per_tile_desktop * 5);
        width_desktop = columns_per_tile_desktop * 5;
        width_mobile = columns_per_tile_mobile * 2;
      break;
      default:
        classes = 'column-xs-' + columns_per_tile_mobile + ' column-sm-' + columns_per_tile_desktop;
        width_desktop = columns_per_tile_desktop;
        width_mobile = columns_per_tile_mobile;
    }

    if (device === 'desktop') {
      classes += ' hidden--mobile';
    }
    if (device === 'mobile') {
      classes += ' hidden--desktop';
    }
    %><marketing-block id="<%= 'mb-' + device  %>" data-collection-marketing-block data-format="<%= data.format %>" data-width-desktop="<%= width_desktop %>" data-width-mobile="<%= width_mobile %>" class="plp-mb plp-mb--main animate animate--fadeInUp <%= classes %>"<% if (data.button_url.length > 0) { %> data-url="<%= data.button_url %>" style="cursor: pointer;"<% } %> tabindex="0" title="Marketing block">
      <div class="plp-mb__container">
        <div class="plp-mb__tile plp-mb-tile">
          <% if (data.pretitle.length > 0) { %><h4 class="plp-mb-tile__pretitle" tabindex="0"><%= data.pretitle %></h4><% } %>
          <% if (data.title.length > 0) { %><h3 class="plp-mb-tile__title" tabindex="0"><%= data.title %></h3><% } %>
          <% if (data.description.length > 0) { %><p class="plp-mb-tile__description" tabindex="0"><%= data.description %></p><% } %>
          <% if (data.custom_html.length > 0) { %><div class="plp-mb-tile__html" tabindex="0"><%= data.custom_html %></div><% } %>
          <% if (data.button_title.length > 0 && data.button_url.length > 0) { %><a tabindex="0" role="button" href="<%= data.button_url %>" class="btn btn--primary plp-mb-tile__cta" aria-label="<%= data.button_title %>"><%= data.button_title %></a><% } %>
        </div>
      </div>
    </marketing-block>`;
};

const marketingBlockExtraTemplate = () => {
  return `<%
    var classes = '';

    if (data.type === 'mb_extra_desktop') {
      classes += 'column-xs-' + (columns_per_tile_desktop * data.width);
      classes += ' hidden--mobile';
    }

    if (data.type === 'mb_extra_mobile') {
      classes += 'column-xs-' + (columns_per_tile_mobile * data.width);
      classes += ' hidden--desktop';
    }
    %><marketing-block id="<%= id %>" data-collection-marketing-block data-width="<%= data.width %>" data-position="<%= data.position %>" class="plp-mb plp-mb--extra animate animate--fadeInUp <%= classes %>" tabindex="0" title="Marketing block extra"<% if (data.add_bottom_spacing === true) { %> style="margin-bottom: 20px;"<% } %>>
      <div class="plp-mb__container">
        <a href="<%= data.url %>" class="plp-mb__tile">
          <img src="<%= data.background_image %>" width="300" height="460" alt="<%= data.image_alt %>" />
        </a>
      </div>
    </marketing-block>`;
};

// Only add it to the 1st page on mobile
const isFirstPageMobile = () => {
  const current_page_el = document.querySelector('[data-current-page]');
  return !(window.theme.breakpoints.current === 'mobile' && current_page_el && Number(current_page_el.textContent) > 1);
};

// A product tile takes 1 spot
// A marketing block can take from 1 to 5 spots
const getExtraMarketingBlockPositionIndex = (marketing_block_data) => {
  const screen = (marketing_block_data.type === 'mb_extra_desktop') ? 'desktop' : 'mobile';
  let total_items = 0;
  let total_spaces = 0; // for instance, a product tile takes 1 space (3 columns)
  let matching_index = 0;
  // Using _.some in order to be able to break the loop
  _.some($(`.collection-grid-section [data-product-tiles] .grid > *`), item => {
    total_items++;
    const item_screen = $(item).hasClass('hidden--mobile') ? 'desktop' : 'mobile';
    const needed_pos = marketing_block_data.position;

    if ($(item).hasClass('product-tile')) {
      total_spaces += 1;
    }

    // Regular marketing block
    if ($(item).hasClass('plp-mb--main')) {
      // Keep in mind that mobile MB extra haven't been populated yet
      if (screen === 'desktop') {
        total_spaces += (item_screen === 'desktop') ? (Number($(item).data('width-desktop')) / columns_per_tile_desktop) : 0;
      }

      // Keep in my that desktop MB extra have already been populated at this point
      if (screen === 'mobile') {
        total_spaces += (item_screen === 'mobile') ? (Number($(item).data('width-mobile')) / columns_per_tile_mobile) : 0;
      }
    }

    // Extra marketing block
    if ($(item).hasClass('plp-mb--extra')) {
      if (screen === 'desktop') {
        total_spaces += (item_screen === 'desktop') ? (Number($(item).data('width')) * columns_per_tile_desktop) / columns_per_tile_desktop : 0;
      }

      if (screen === 'mobile') {
        total_spaces += (item_screen === 'mobile') ? Number($(item).data('width')) : 0;
      }
    }

    if (total_spaces === needed_pos - 1) {
      // matching_index = $(item).index() + 1 + 1; // (next index + 1) nth-child is 1 based while index() is 0 based
      matching_index = total_items; // (next index + 1) nth-child is 1 based while index() is 0 based
      return true;
    }
  });

  return matching_index;
};

export default () => {
  const main_block_el = document.querySelector('[data-collection-marketing-block-json]');
  const extra_blocks_el = document.querySelector('[data-collection-extra-marketing-blocks-json]');
  
  if (!main_block_el && !extra_blocks_el) {
    return;
  }

  if (!isFirstPageMobile()) {
    return;
  }

  let retry_set_height = 3;

  $(document).on('click', '[data-collection-marketing-block]', (e) => {
    const $item = $(e.currentTarget);

    if (typeof $item.data('url') === 'undefined' || !$item.data('url').length) {
      return;
    }

    window.location.href = $item.data('url');
  });

  // [ADA]
  $(document).on('keypress', '[data-collection-marketing-block]', (e) => {
    const key = e.which;
  
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });
console.log('.... register event');
  document.addEventListener('astr-plp-tiles-built', (e) => {
    console.log('astr-plp-tiles-built event', e.data);
    if (e.data.from_search || e.data.filtered || ($('[data-collection-marketing-block]').length && !$('[data-collection-extra-marketing-blocks-json]').length)) {
      return;
    }

    if (!isFirstPageMobile()) {
      return;
    }

    if (!$('.plp-mb--main').length && $('[data-collection-marketing-block-json]').length) {
      const marketing_block_json = JSON.parse($('[data-collection-marketing-block-json]').text());
      // console.log('marketing_block_json', marketing_block_json);

      const compiled = _.template(marketingBlockTemplate(), {imports: { jq: $ } });
      const marketing_block_html_desktop = compiled({ data: marketing_block_json, device: 'desktop', columns_per_tile_desktop, columns_per_tile_mobile });
      const marketing_block_html_mobile = compiled({ data: marketing_block_json, device: 'mobile', columns_per_tile_desktop, columns_per_tile_mobile });

      // Desktop marketing block is the very first one injected, its initial position never changes
      $(`.collection-grid-section [data-product-tiles] .grid [data-product-tile]:nth-child(${marketing_block_json.position_desktop})`).before(marketing_block_html_desktop);

      const pos_mobile = (marketing_block_json.position_mobile < marketing_block_json.position_desktop) ? marketing_block_json.position_mobile : marketing_block_json.position_mobile + 1;
      $(`.collection-grid-section [data-product-tiles] .grid [data-product-tile]:nth-child(${pos_mobile})`).before(marketing_block_html_mobile);
    }

    // window.setTimeout(() => {
      if (!$('.plp-mb--extra').length && $('[data-collection-extra-marketing-blocks-json]').length) {
        let marketing_block_extra_json = JSON.parse($('[data-collection-extra-marketing-blocks-json]').text());
        marketing_block_extra_json = _.sortBy(marketing_block_extra_json, ['type', 'position']);

        // We need 2 different loops, else don't don't see the added items with JS within getExtraMarketingBlockPositionIndex()
        const marketing_block_extra_desktop = _.filter(marketing_block_extra_json, { type: 'mb_extra_desktop' });
        const marketing_block_extra_mobile = _.filter(marketing_block_extra_json, { type: 'mb_extra_mobile' });

        for (let i = 0; i < marketing_block_extra_desktop.length; i++) {
          const block_data = marketing_block_extra_desktop[i];
          const compiled = _.template(marketingBlockExtraTemplate(), {imports: { jq: $ } });
          const marketing_block_html = compiled({ data: block_data, columns_per_tile_desktop, columns_per_tile_mobile, id: `mbx-desktop-${i + 1}` });
          const real_position = getExtraMarketingBlockPositionIndex(block_data);
          // console.log(`===== Type: ${block_data.type} // Old pos: ${block_data.position} // New pos: ${real_position}`);
          // $(`.collection-grid-section [data-product-tiles] .grid [data-product-tile]:nth-child(${real_position})`).before(marketing_block_html);
          $(`.collection-grid-section [data-product-tiles] .grid`).children().eq(real_position).before(marketing_block_html);
        }

        for (let i = 0; i < marketing_block_extra_mobile.length; i++) {
          const block_data = marketing_block_extra_mobile[i];
          const compiled = _.template(marketingBlockExtraTemplate(), {imports: { jq: $ } });
          const marketing_block_html = compiled({ data: block_data, columns_per_tile_desktop, columns_per_tile_mobile, id: `mbx-mobile-${i + 1}` });
          const real_position = getExtraMarketingBlockPositionIndex(block_data);
          // console.log(`===== Type: ${block_data.type} // Old pos: ${block_data.position} // New pos: ${real_position}`);
          // $(`.collection-grid-section [data-product-tiles] .grid [data-product-tile]:nth-child(${real_position})`).before(marketing_block_html);
          $(`.collection-grid-section [data-product-tiles] .grid`).children().eq(real_position).before(marketing_block_html);
        }

        /*
        let device = '';
        let device_index = 0;
        for (let i = 0; i < marketing_block_extra_json.length; i++) {
          const block_data = marketing_block_extra_json[i];
          const compiled = _.template(marketingBlockExtraTemplate(), {imports: { jq: $ } });
          const marketing_block_html = compiled({ data: block_data, columns_per_tile_desktop, columns_per_tile_mobile, id: `mbx-${i + 1}` });
          // console.log(block_data.position, marketing_block_html);
          if (device !== block_data.type) {
            device = block_data.type;
            device_index = 0;
          } else {
            device_index++;
          }
          const real_position = getExtraMarketingBlockPositionIndex(block_data, device_index);
          console.log(`Type: ${block_data.type} // Old pos: ${block_data.position} // New pos: ${real_position}`);

          // if (real_position > 0) {
            // window.setTimeout(() => {
            $(`.collection-grid-section [data-product-tiles] .grid [data-product-tile]:nth-child(${real_position})`).before(marketing_block_html);
            // }, 100);
          // }
        }
        */

        // const compiled_mobile = _.template(`
        //   <% jq.each(data, function(index) { %>${marketingBlockExtraTemplate()}<% }); %>
        // `, {imports: { jq: $ } });
        // const marketing_block_extra_html_mobile = (marketing_block_extra_mobile.length) ? compiled_mobile({ data: marketing_block_extra_mobile }) : '';
  
        // Keep in mind that mobile positions need to be recalculated after injected desktop items
  
        // $(`.collection-grid-section [data-product-tiles] .grid [data-product-tile]:nth-child(${marketing_block_json.position_desktop})`).before(marketing_block_html_desktop);
        // $(`.collection-grid-section [data-product-tiles] .grid [data-product-tile]:nth-child(${marketing_block_json.position_mobile})`).before(marketing_block_html_mobile);
      }
    // }, 100);

    // Trigger a resize and scroll to make sure we're calling the resizing and animating functions set on the product tiles
    // We use the 1st tile so a delay is necessary due to the image loading time
    window.setTimeout(() => {
      // Dispatch events for new functionalities
      const mb_built_event = new CustomEvent('astr-plp-mb-built', { bubbles: true });
      document.dispatchEvent(mb_built_event);

      animate();
    }, 100);
  });

  document.addEventListener('astr-plp-layout-changed', (e) => {
    console.log('astr-plp-layout-changed', e.data);

    $('[data-format="tile"]').removeClass('column-sm-2').removeClass('column-sm-3').removeClass('column-sm-4').removeClass('column-sm-5').removeClass('column-sm-6');
    $('[data-format="half"]').removeClass('column-sm-2').removeClass('column-sm-3').removeClass('column-sm-4').removeClass('column-sm-5').removeClass('column-sm-6');
    $('[data-format="full"]').removeClass('column-sm-15');

    if (e.data.items_per_rows === 2) {
      $('[data-format="tile"]').addClass('column-sm-6');
      $('[data-format="half"]').addClass('column-sm-6');
    }

    if (e.data.items_per_rows === 3) {
      $('[data-format="tile"]').addClass('column-sm-4');
      $('[data-format="half"]').addClass('column-sm-4');
    }

    if (e.data.items_per_rows === 4) {
      $('[data-format="tile"]').addClass('column-sm-3');
      $('[data-format="half"]').addClass('column-sm-6');
    }

    // We're using a 15 grid layout
    if (e.data.items_per_rows === 5) {
      $('[data-format="tile"]').addClass('column-sm-3');
      $('[data-format="half"]').addClass('column-sm-6');
      $('[data-format="full"]').addClass('column-sm-15');
    }

    window.setTimeout(() => {
      $(window).trigger('resize');
      $(window).trigger('scroll');
    }, 200);
  });

  $(window).on('resize', _.debounce(() => {
    if (!$('[data-collection-marketing-block]').length || !$('.collection-grid-section [data-product-tile]').length) {
      return;
    }

    const image_height = $('.collection-grid-section [data-product-tile]').first().find('[data-product-main-image]').outerHeight();

    // The image might now be loaded at this point, try up to 3 times using a delay
    if (image_height === 0 && retry_set_height > 0) {
      retry_set_height--;

      window.setTimeout(() => {
        $(window).trigger('resize');
      }, 200);

      return;
    }

    if (image_height > 0) {
      if ($('[data-collection-marketing-block].plp-mb--main').data('format') === 'full') {
        $('[data-collection-marketing-block].plp-mb--main.hidden--mobile').css('min-height', `${image_height / 2}px`);
        $('[data-collection-marketing-block].plp-mb--main.hidden--desktop').css('height', `${image_height}px`);
      } else {
        $('[data-collection-marketing-block].plp-mb--main').css('height', `${image_height}px`);
      }

      $('[data-collection-marketing-block].plp-mb--extra').css('height', `${image_height}px`);
    }
  }, 10));
};
